export default function Header({ showSaved, setShowSaved }) {
  return (
    <div className="header">
      <div className="header-content">
        <h1>Color Palette Generator</h1>
        <p>Create beautiful color combinations with a single click</p>
      </div>
      <button
        onClick={() => setShowSaved(!showSaved)}
        className="saved-colors-btn"
      >
        {showSaved ? "Back to generator" : "Saved colors"}
      </button>
    </div>
  );
}
